// extracted by mini-css-extract-plugin
module.exports = {"container":"Error404Page_container__37c-X","title":"Error404Page_title__rpnLU","text":"Error404Page_text__e7GIs","button":"Error404Page_button__2QpyE"};